import { unknown } from './unknown';
export var blockCard = function blockCard(node) {
  if (!node.attrs.url) {
    return unknown(node);
  }
  return "[".concat(node.attrs.url, "|").concat(node.attrs.url, "|smart-card]");
};